const AnjuMusicVideosStatic = () => {
    return (
      <>
        <div class="music-video">

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/Bs84gP1d888" title="Katy" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Katy</strong>
          </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/0PDDyumLrYo" title="SWAG SUPPLIER" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>SWAG SUPPLIER</strong> (feat. Kawaii Ry & STARINTHESKY)
          </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/kXeKwQsEtg4" title="Hellscape Radio Vol. 3" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Hellscape Radio, Vol. 3</strong> (Hosted by ANJU Online!)
          </p>

        </div>
      </>
    );
  };
  export default AnjuMusicVideosStatic;